import { useState, useEffect } from 'react';
import type { QuoteData } from '@/types/bot';
import { quoteAPI } from '@/services/api';

export function useQuotes(symbols?: string[], refreshInterval = 30_000) {
  const [quotes, setQuotes] = useState<Record<string, QuoteData>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchQuotes() {
      try {
        const data = await quoteAPI.getQuotes(symbols);
        if (mounted) {
          setQuotes(data);
          setLoading(false);
        }
      } catch {
        if (mounted) setLoading(false);
      }
    }

    fetchQuotes();
    const id = setInterval(fetchQuotes, refreshInterval);
    return () => { mounted = false; clearInterval(id); };
  }, [symbols?.join(','), refreshInterval]);

  return { quotes, loading };
}
